// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./magaele/btg_gpct/css.scss
// module id = 14
// module chunks = 0 1 3 4 6